module.exports = __webpack_public_path__ + "img/image (16).285399af.png";